import { ToastrManager } from 'ng6-toastr-notifications';
import { User } from 'src/app/shared/models/user.model';
import { UsersService } from 'src/app/shared/services/users.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'users-detail',
  templateUrl: './users-detail.component.html',
  styleUrls: ['./users-detail.component.css']
})
export class UsersDetailComponent implements OnInit {
  
  public user:User;

  constructor(public aRoute: ActivatedRoute, public toastr:ToastrManager,public navigator:Router,public userServ:UsersService){
    this.user=new User();
  }

  ngOnInit() {
    this.userServ.getObject('userr')
    .subscribe(user=>this.user=user)
  }

  editUser(user:User){
    this.navigator.navigate(['/admin/users/edit'])
  }

  
  updateImageProfile(event:any,partner:any){
    if(confirm('Deseja realmente actualizar o Logotipo?')){

            // criando um formData
            let formData = new FormData();


            // convertendo o formpartner para formData
            formData.append('id', partner['id'])
      
            console.log(event.target.files[0])
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('picture', event.target.files[0], event.target.files[0].name)

      // save image
      this.userServ.updateImageWithNoData(formData,'userr')
      .subscribe(message=>{
        this.toastr.successToastr(message)
      })

    }
  }
}
